import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import MobileFriendlyIcon from '@mui/icons-material/MobileFriendly'
import PhoneIcon from '@mui/icons-material/Phone'
import VpnKeyRoundedIcon from '@mui/icons-material/VpnKeyRounded'
import { Box, Container, InputAdornment, Typography } from '@mui/material'
import { Dispatch } from '@reduxjs/toolkit'
import { useSnackbar } from 'notistack'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import swal from 'sweetalert'
import * as Yup from 'yup'

import '../../Style.css'
import * as routes from '../../config/constants'
import Button from '../../shared/Button'
import { Form, FormField, SubmitButton } from '../../shared/forms'
import LoadingButtonForm from '../../shared/forms/LoadingButtonForm'
import { getLoading, getRegisterUserId, receiveAppToken, register } from '../../store/auth'
import {
  getDevice,
  getError,
  getMessage,
  registerDevice,
  setError,
  setMessage,
} from '../../store/devices'
interface FormValues {
  id: string
}
// Define interface and  validationSchema form
const initialValues: FormValues = { id: '' }

const validationSchema = Yup.object().shape({
  id: Yup.string()
    .required('وارد کردن شماره شناسایی دستگاه الزامی است')
    .label('id device')
    .max(15, 'حداکثر تا 15 رقم مجاز است')
    .matches(/^[0-9]*$/, 'لطفا شماره شناسایی دستگاه را به درستی وارد نمایید'),
})

const RegisterDeviceScreen: React.FC = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch<Dispatch<any>>()
  const loading = useSelector(getLoading)
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar()
  const error = useSelector(getError)
  const message = useSelector(getMessage)
  const handleSubmit = (values: any) => {
    dispatch(registerDevice(values))
  }

  useEffect(() => {
    if (error === undefined) return
    enqueueSnackbar(error, { variant: 'error' })

    dispatch(setError(undefined))
  }, [error])
  useEffect(() => {
    if (message === undefined) return
    enqueueSnackbar(message, { variant: 'success' })
    dispatch(setMessage(undefined))
    navigate(`/${routes.DEVICES}`)
  }, [message])

  return (
    <Container fixed maxWidth='xs'>
      <Box display='grid' gridTemplateColumns='auto auto' sx={{ mt: 2, mb: 2, direction: 'ltr' }}>
        <ArrowBackRoundedIcon
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: 'red',
            borderRadius: '50%',
            color: '#fff',
            cursor: 'pointer',
          }}
        />
        <img alt='Logo' src='/images/TinyLogo.png' />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',

          direction: 'ltr',
        }}
      >
        <Box
          className='bg'
          display='flex'
          height='190px'
          justifyContent='center'
          sx={{
            border: '5px solid #fff',
            borderRadius: '25% 25% 25% 0% / 25% 25% 25% 25%',
            alignSelf: 'center',
            boxShadow: '5px 7px 30px black',
            mb: 5,
          }}
          width='190px'
        >
          <img alt='Logo' height='150px' src='images/Logo1.png' width='150px' />
        </Box>
        <Box sx={{ mb: 2, ml: 1, alignSelf: 'flex-end' }}>
          <Typography sx={{ color: 'grey.700' }} variant='h5'>
            {t('screens.deviceList.registerDevice_title_text')}
          </Typography>
        </Box>
        <Form
          initialValues={initialValues}
          onSubmit={handleSubmit}
          validationSchema={validationSchema}
        >
          <FormField
            name='id'
            placeholder={t('screens.deviceList.idNumber_input_text')}
            startAdornment={
              <InputAdornment position='start'>
                <MobileFriendlyIcon />
              </InputAdornment>
            }
          />

          <LoadingButtonForm
            loading={loading}
            title={t('screens.deviceList.submit_button_text')}
            variant='contained'
          />
        </Form>
      </Box>
    </Container>
  )
}

export default RegisterDeviceScreen
